// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2lvq4","itemTitle":"ClientEmergencyInfo_itemTitle__30E4C","itemText":"ClientEmergencyInfo_itemText__1MOQ4"};